<template>
    <div class="page-container">
        <div class="order-page-header">{{ localize('我的订单') }}</div>
        <template v-if="this.orderList.length === 0">
            <div class="empty-order-container">
                <img class="empty-order-img" src="../images/empty.svg" alt="empty">
                <div class="empty-order-text">{{localize('空')}}</div>
            </div>
        </template>
        <div class="order-list-container">
            <template v-for="(item) in this.orderList" :key="item.tx">
                <div class="order-container">
                    <div class="order-time">{{localize('创建时间：') +  item.createTimeString }}</div>
                    <div class="order-tx">{{localize('節點類型：') + this.getNodeTypeTxt(item.purchaseNodeType) }}</div>
                    <div class="order-tx">{{localize('金額：') +  `${item.paymentAmount} USDT` }}</div>
                    <div class="order-tx">{{localize('转账哈希：') + this.getShortenHashTx(item.tx) }}</div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>

import {postRequestAsync} from '@/utils/request'
import {maskBscAddress, maskTxHash} from "@/utils/web3Helper";
import {showToast} from '@/utils/toastHelper'
import {hideLoading, showLoading} from '@/utils/spinnerHelper'

export default {
    name: 'OrderPage',
    props: {
        msg: String
    },
    inject: ['langStore', 'localize'],
    data() {
        return {
            orderList: []
        }
    },
    watch: {
        async myWalletAddress(newVal, oldVal) {
            console.log('watch myWalletAddress')
            if (!newVal) return
            // 若地址没变（某些情况下重复提交相同值），可直接返回
            if (newVal === oldVal) return

            await this.getMyOrders()
        }
    },
    computed: {
        myWalletAddress() {
            console.log('computed myWalletAddress')
            return this.$store.state.connectedWallet
        }
    },
    async mounted() {
        try {
            showLoading()
            if (this.myWalletAddress) {
                await this.getMyOrders()
            }
        } finally {
            hideLoading()
        }
    },
    methods: {
        async getMyOrders() {
            if (!this.myWalletAddress) {
                showToast(this.localize('请连接钱包'))
                return
            }
            const result = await postRequestAsync('order/getMyNodeOrder', {purchaseWallet: this.myWalletAddress})

            if (result?.code === 200) {
                if (Array.isArray(result?.msg?.orders) && result?.msg?.orders?.length > 0) {
                    this.orderList = result?.msg?.orders
                }
            }
        },
        getShortenHashTx(tx) {
            return maskTxHash(tx)
        },
        getNodeTypeTxt(type) {
            if (type === 'basic') {
                return this.localize("初級節點")
            }
            return this.localize("高級節點")
        }
    }
}
</script>

<style scoped>

.order-page-header {
    font-size: 2em;
    color: #38FF59;
}

.empty-order-img {
    width: 12em;
    padding: 1em;
    box-sizing: border-box;
}

.empty-order-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1em;
    opacity: 0.5;
    padding: 3em;
    box-sizing: border-box;
}

.empty-order-text {
    font-size: 2em;
    color: #38FF59;
}

.order-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 2px solid #38FF59;
    padding: 1em;
    box-sizing: border-box;
    align-items: start;
    gap: 0.8em;
    border-radius: 0.4em;
}

.order-time {
    font-size: 1.6em;
    color: #38FF59;
}

.order-tx {
    font-size: 1.6em;
    color: #38FF59;
    width: 100%;
    overflow-x: hidden;
    word-wrap: break-word;
}

.order-list-container {
    width: 100%;
    padding: 1em 0;
    box-sizing: border-box;
    text-align: start;
}
</style>